import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('token');
          setToken(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    try {
      console.log('Tentative de connexion:', email);
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);
      
      const res = await api.post('/auth/login', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      
      console.log('Réponse login:', res.data);
      const { access_token, user: userData } = res.data;
      
      localStorage.setItem('token', access_token);
      setToken(access_token);
      setUser(userData);
      
      navigate(userData.role === 'auditor' ? '/auditor' : '/sponsor');
    } catch (error) {
      console.error('Erreur login:', error.response?.data || error.message);
      throw new Error(error.response?.data?.detail || 'Erreur de connexion');
    }
  };

  const register = async (name, email, password, role) => {
    try {
      console.log('Tentative d\'inscription:', { name, email, role });
      const res = await api.post('/auth/register', {
        name,
        email,
        password,
        role
      });
      
      console.log('Réponse register:', res.data);
      const { access_token, user: userData } = res.data;
      
      localStorage.setItem('token', access_token);
      setToken(access_token);
      setUser(userData);
      
      navigate(userData.role === 'auditor' ? '/auditor' : '/sponsor');
    } catch (error) {
      console.error('Erreur register:', error.response?.data || error.message);
      throw new Error(error.response?.data?.detail || 'Erreur d\'inscription');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    navigate('/');
  };

  const refreshUser = async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
    } catch (error) {
      console.error('Erreur refresh user:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
